module.exports = __webpack_public_path__ + "assets/img/b3c32fd9c8cfe5da73082ca794385893.png";